import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CreateTicketForm from './modules/CreateTicketForm';
import { submitSupportTicket } from '../../../services/supportApi';
import { INITIAL_TICKET_FORM, resolveSupportError } from './supportUtils';
import './SupportSection.css';

const TICKET_GUIDES = [
  'Describe el impacto en tu operación (clientes afectados, plazos, etc.).',
  'Indica si ya intentaste alguna solución y qué resultados obtuviste.',
  'Comparte enlaces o referencias (Drive, capturas, logs) con acceso público.',
];

export default function SupportCreateTicketSection({ user, empresaId }) {
  const [formValues, setFormValues] = useState(() => ({ ...INITIAL_TICKET_FORM }));
  const [submitError, setSubmitError] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const userId = user?.id || '';
  const companyId = empresaId || '';

  const handleInputChange = event => {
    const { name, value } = event.target;
    setFormValues(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitTicket = async event => {
    event.preventDefault();
    if (!userId) {
      setSubmitError('Debes iniciar sesion para crear un ticket.');
      return;
    }

    setSubmitting(true);
    setSubmitError('');
    setSubmitSuccess('');

    try {
      await submitSupportTicket({
        ...formValues,
        reporterId: userId,
        companyId: companyId || undefined,
        reporterName: user?.name || user?.username || '',
        reporterEmail: user?.email || '',
      });
      setFormValues(() => ({ ...INITIAL_TICKET_FORM }));
      setSubmitSuccess('Tu ticket fue enviado. Te contactaremos a la brevedad.');
      window.setTimeout(() => {
        navigate('/dashboard?section=support-tickets');
      }, 1200);
    } catch (error) {
      setSubmitError(resolveSupportError(error));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="support-shell support-create">
      <header className="support-create__hero">
        <div className="support-create__intro">
          <span className="support-create__kicker">Centro de ayuda</span>
          <div className="support-create__title-row">
            <h1>Crear ticket de soporte</h1>
            <Link
              to="/dashboard?section=support-tickets"
              className="support-create__secondary"
            >
              Ver mis tickets
            </Link>
          </div>
          <p className="support-create__subtitle">
            Comparte contexto, prioridad y evidencias para que podamos desbloquear tu operación sin
            fricciones. Un especialista asignado dará seguimiento en el mismo hilo y por correo.
          </p>
        </div>
      </header>

      <div className="support-create__body">
        <div className="support-create__form">
          <CreateTicketForm
            values={formValues}
            onChange={handleInputChange}
            onSubmit={handleSubmitTicket}
            submitting={submitting}
            error={submitError}
            success={submitSuccess}
          />
        </div>
        <div className="support-create__panel">
          <div className="support-create__panel-head">
            <span className="support-create__eyebrow">Antes de enviar</span>
            <h2>Checklist rápido</h2>
            <p>
              Mientras más claro sea el contexto, más rápido podremos intervenir o escalarlo al
              equipo técnico correspondiente.
            </p>
          </div>
          <ul className="support-create__list">
            {TICKET_GUIDES.map(item => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <div className="support-create__hint">
            ¿Caso urgente? Marca la prioridad <strong>Alta</strong> y llama a tu contacto de Customer
            Success para activar el canal de guardias.
          </div>
        </div>
      </div>
    </section>
  );
}
